videojs.addLanguage('fr', {
  "Yes": "Oui",
  "No": "Non",
  "Nsp": "Je ne sais pas"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_skin_control_bar/dist/lang/fr.js
// module id = 538
// module chunks = 39